"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configType = void 0;
const prop_types_1 = require("prop-types");
exports.configType = (0, prop_types_1.shape)({
    enable_hide_scheduling_help_messages: prop_types_1.bool,
    recaptchaSiteKey: prop_types_1.string.isRequired,
    render_type: prop_types_1.string
});
//# sourceMappingURL=propTypes.js.map